import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-location';

import pageCatalog from 'pages/pageCatalog';
import { getMagicMovieUserName } from 'store/magicMovie';
import { useAppSelector } from 'store/utils/hooks';

import gameColdStartImage from 'common/assets/magicMovie/game-coldstart-01.png';

import './styles.css';

export const MagicMovieColdStart: React.FC = () => {
  const { t } = useTranslation(['magicMovie']);
  const navigate = useNavigate();
  const userName = useAppSelector(getMagicMovieUserName);

  return (
    <div id="game" className="gameContainer" data-test-id="magicMovieColdStartRoot">
      <div className="limitLine" id="cold-start-conatiner">
        <div className="header-spaced" id="cold-start-header-img">
          <img src={gameColdStartImage} alt="Cold start Image" />
        </div>
        <h1 className="title-spaced">{t('coldStart.title')}</h1>
        <p className="blue">{t('coldStart.welcomeUser', { userName: userName })}</p>
        <p className="blue" style={{ marginBottom: '40px', marginTop: 0 }}>
          {t('coldStart.situation', { userName: userName })}
        </p>
        <button
          className="customButton"
          onClick={() => {
            navigate({ to: pageCatalog['MagicMovieGrid'].route });
          }}
          data-test-id="magicMovieColdStartContinueButton"
        >
          {t('coldStart.showMovies')}
        </button>
      </div>
    </div>
  );
};
